import {
  FaUserClock,       // シフト提出期間
  FaCalendarTimes,   // 休校日設定
  FaCalendarCheck,   // 固定シフト
  FaBan,             // 出席不可コマ設定
  FaChalkboardTeacher, // 講師スケジュール（維持）
  FaUserFriends,     // 生徒スケジュール（変更）
  FaRegClipboard, // 勤務可能調査（アイコン更新）
  FaKey,
  FaCamera,             // パスワード登録（維持）
} from "react-icons/fa";

export const schedulePages = [
  {
    path: "/win",
    match: "exact",
    title: "シフト提出期間",
    icon: <FaUserClock />,
    showInSidebar: true,
    visibleTo: ["admin"],
  },
  {
    path: "/holiday",
    match: "exact",
    title: "休校日設定",
    icon: <FaCalendarTimes />,
    showInSidebar: true,
    visibleTo: ["admin"],
  },
  {
    path: "/regular",
    match: "exact",
    title: "固定シフト",
    icon: <FaCalendarCheck />,
    showInSidebar: true,
    visibleTo: ["admin"],
  },
  {
    path: "/su",
    match: "exact",
    title: "出席不可コマ設定",
    icon: <FaBan />,
    showInSidebar: true,
    visibleTo: ["admin"],
  },
  {
    path: "/teacher",
    match: "exact",
    title: "講師スケジュール",
    icon: <FaChalkboardTeacher />,
    showInSidebar: true,
    visibleTo: ["admin"],
  },
  {
    path: "/student",
    match: "exact",
    title: "生徒スケジュール",
    icon: <FaUserFriends />,
    showInSidebar: true,
    visibleTo: ["admin"],
  },
  {
    path: "/snapshot",
    match: "exact",
    title: "スナップショット",
    icon: <FaCamera />,
    showInSidebar: true,
    visibleTo: ["admin"],
  },
  {
    path: "/diary",
    match: "exact",
    title: "今日の予定",
    icon: <FaCamera />,
    showInSidebar: true,
    visibleTo: ["admin"],
  },
  {
    path: "/shift",
    match: "exact",
    title: "勤務可能調査",
    icon: <FaRegClipboard />,
    showInSidebar: true,
    visibleTo: ["teacher"],
  },
  {
    path: "/schedule",
    match: "exact",
    title: "スケジュール",
    icon: <FaCalendarCheck />,
    showInSidebar: true,
    visibleTo: ["teacher"],
  },
  {
    path: "/welcome",
    match: "exact",
    title: "パスワード登録",
    icon: <FaKey />,
    showInSidebar: false,
    visibleTo: ["admin", "teacher"],
  },
];
